.root {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    min-height: 43.5px;
    background: var(--mui-palette-common-white, #fff);
    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
}

.inner {
    display: flex;
    align-items: center;
    column-gap: 0;
    flex: 1;
    min-width: 0;
    padding-left: 8px;
    padding-right: 8px;
}

.trailing {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 0;
    padding-left: 8px;
    padding-right: 8px;
}

.trailing .MuiIconButton-root {
    padding: 0;
}
